class CartPackUpsell extends HTMLElement {
  constructor() {
    super();
    this.upsellItem = null;
    this.selectedVariant = null;
    this.packName = null;
    this.packDetails = null;
    this.cartPackCount = 0;
    this.cartVariant = null ;
    this.offeringPack = null;
    this.upsellLastChanceColors = [];
    this.upsellHandle = null;
    this.init();
  }

  async fetchUpsellLastChanceColors(handle) {
  this.upsellLastChanceColors = [];
  this.upsellHandle = handle;

  try {
    const res = await fetch(`/products/${handle}?section_id=upsell-last-chance-meta`);
    if (!res.ok) return;

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const script = doc.querySelector('script[data-upsell-last-chance]');
    if (!script) return;

    const raw = (script.textContent || '').trim();
    if (!raw) return;

    let value;
    try { value = JSON.parse(raw); } catch(e) { value = raw; }

    const str = Array.isArray(value) ? value.join(',') : String(value);
    this.upsellLastChanceColors = str.split(',').map(v => v.trim().toLowerCase()).filter(Boolean);
  } catch (e) {}
}

  async getUpsellItem() {
    // Find a cart row that has data-has-pack="true" (in the drawer DOM)
    const cartDrawer = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    const packRow = cartDrawer ? cartDrawer.querySelector('tr.cart-item[data-pack-name]') : null;
    this.packName = packRow ? packRow.getAttribute('data-pack-name') : null;
    this.packDetails = packRow ? packRow.getAttribute('data-pack-details') : null;
    const lastChanceRaw = packRow ? (packRow.getAttribute('data-last-chance-colors') || '') : '';
    this.lastChanceColorsRaw = lastChanceRaw;
    this.lastChanceColors = lastChanceRaw
      .split(',')
      .map(v => v.trim().toLowerCase())
      .filter(Boolean);

    let handle = 'all-season-ankle-socks';
    if (!packRow) {
      // If no pack row found, check first cart product title for Men/Women
      const firstCartItem = cartDrawer ? cartDrawer.querySelector('tr.cart-item:first-child') : null;
      if (firstCartItem) {
        const productTitle = firstCartItem.querySelector('.cart-item__name')?.textContent || '';
        if (productTitle.toLowerCase().includes('women'))  {
          handle = 'womens-merino-ankle-socks';
        } else  {
          handle ='all-season-ankle-socks';
        }
      }
      this.cartVariant = 'Black';
      this.offeringPack = false;
    } else {
      // extra checking for giftbox packs, keep suggesting the default socks upsell
      let expectedProductHandleToRecommend = packRow.getAttribute('data-product-handle');
      if (typeof handlesForceHiddenFromCartUpselling !== 'undefined') {
        let hiddenHandles = handlesForceHiddenFromCartUpselling.split(',').map(h => h.trim());
        // Check if expected handle is NOT in the hiddenHandles array
        if (!hiddenHandles.includes(expectedProductHandleToRecommend)) {
          handle = expectedProductHandleToRecommend;
          this.cartVariant = packRow.getAttribute('data-variant-title') || '';
          this.offeringPack = true;
        }
      }
    }

    if (!handle) return null;
    await this.fetchUpsellLastChanceColors(handle);

    try {
      const resp = await fetch(`/products/${handle}.js`);
      if (resp.ok) {
        const product = await resp.json();
        return product;
      }
    } catch (e) {
      console.warn('Upsell: failed to fetch product JSON', e);
    }
    return null;
  }

  isFinalSaleSelected() {
  const color = (this.selectedVariant?.option1 || '').trim().toLowerCase();
  if (!color) return false;
  return this.upsellLastChanceColors.includes(color);
}



  onVariantChange() {
    const selectedColor = this.querySelector('input[name="upsell-Color"]:checked')?.value;
    const selectedSize = this.querySelector('input[name="upsell-Size"]:checked')?.value;
    
    // Dynamically find the third option (any option that's not Color/Colour or Size)
    const allOptionInputs = this.querySelectorAll('input[name^="upsell-"]:checked');
    let selectedThird = null;
    allOptionInputs.forEach(input => {
      const optionName = input.name.replace('upsell-', '');
      if (optionName !== 'Color' && optionName !== 'Colour' && optionName !== 'Size') {
        selectedThird = input.value;
      }
    });

    const parts = [selectedColor, selectedSize, selectedThird].filter(Boolean);
    const searchString = parts.join(' / ');

    this.selectedVariant = this.findMatchingVariant(this.upsellItem, searchString);
    console.log('Selected variant:', this.selectedVariant);

    this.updateUpsellUI();
  }

 
  updateUpsellUI() {
    if (!this.selectedVariant) return;

    if (this.offeringPack) {
      // =============== UI for pack ===============
            // 1. count how many cart  items share the same pack as 
      const cartDrawer = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
      const packRows = cartDrawer ? cartDrawer.querySelectorAll(`tr.cart-item[data-pack-name="${this.packName}"]`) : null;
      this.cartPackCount = 0;
      if (packRows) {
        packRows.forEach(row => {
          const quantityInput = row.querySelector('.quantity__input');
          if (quantityInput) {
            this.cartPackCount += parseInt(quantityInput.value) || 0;
          }
        });
      }


      // Parse pack details
      const packData = JSON.parse(this.packDetails);
      const regularPrice = (this.selectedVariant.compare_at_price) ? this.selectedVariant.compare_at_price / 100 : this.selectedVariant.price / 100; // Convert from cents to dollars
      
      // Find the pack row to get data attributes with converted prices
      // Use the first pack row from the collection (they should all have the same tier prices)
      const packRow = packRows && packRows.length > 0 ? packRows[0] : null;
      
      // Build tiers array (tier 1 is mandatory, 2-4 are optional)
      // Read from data attributes which already have currency conversion applied by Liquid
      const tiers = [];
      
      // Tier 1 (mandatory)
      if (packRow) {
        const tire1Threshold = packRow.getAttribute('data-tire-1-threshold');
        const tire1Price = packRow.getAttribute('data-tire-1-price');
        if (tire1Threshold && tire1Price) {
          tiers.push({
            threshold: parseInt(tire1Threshold),
            price: parseFloat(tire1Price),
            number: 1
          });
        }
      }
      
      // Tier 2 (optional)
      if (packRow) {
        const tire2Threshold = packRow.getAttribute('data-tire-2-threshold');
        const tire2Price = packRow.getAttribute('data-tire-2-price');
        if (tire2Threshold && tire2Price) {
          tiers.push({
            threshold: parseInt(tire2Threshold),
            price: parseFloat(tire2Price),
            number: 2
          });
        }
      }
      
      // Tier 3 (optional)
      if (packRow) {
        const tire3Threshold = packRow.getAttribute('data-tire-3-threshold');
        const tire3Price = packRow.getAttribute('data-tire-3-price');
        if (tire3Threshold && tire3Price) {
          tiers.push({
            threshold: parseInt(tire3Threshold),
            price: parseFloat(tire3Price),
            number: 3
          });
        }
      }
      
      // Tier 4 (optional)
      if (packRow) {
        const tire4Threshold = packRow.getAttribute('data-tire-4-threshold');
        const tire4Price = packRow.getAttribute('data-tire-4-price');
        if (tire4Threshold && tire4Price) {
          tiers.push({
            threshold: parseInt(tire4Threshold),
            price: parseFloat(tire4Price),
            number: 4
          });
        }
      }

      // Sort tiers by threshold (ascending)
      tiers.sort((a, b) => a.threshold - b.threshold);

      // Find current tier index
      let currentTierIndex = -1; // -1 means below all tiers
      for (let i = tiers.length - 1; i >= 0; i--) {
        if (this.cartPackCount >= tiers[i].threshold) {
          currentTierIndex = i;
          break;
        }
      }

      // Calculate quantities left to unlock next tiers
      let quantityLeftForTierA = 0;
      let quantityLeftForTierB = 0;
      
      // Tier A is the next tier after current
      if (currentTierIndex < tiers.length - 1) {
        const nextTierIndex = currentTierIndex + 1;
        quantityLeftForTierA = tiers[nextTierIndex].threshold - this.cartPackCount;
        
        // Tier B is the one after Tier A
        if (nextTierIndex < tiers.length - 1) {
          quantityLeftForTierB = tiers[nextTierIndex + 1].threshold - this.cartPackCount;
        }
      }

      // Calculate savings after adding this upsell
      const currentQuantity = this.cartPackCount;
      const newQuantity = currentQuantity + 1;
      
      // Function to get price per item for a given quantity
      const getPriceForQuantity = (quantity) => {
        for (let i = tiers.length - 1; i >= 0; i--) {
          if (quantity >= tiers[i].threshold) {
            return tiers[i].price;
          }
        }
        return regularPrice; // Below all tiers
      };
      
      const currentPricePerItem = getPriceForQuantity(currentQuantity);
      const newPricePerItem = getPriceForQuantity(newQuantity);
      
      // Calculate total costs
      const currentTotalCost = currentPricePerItem * newQuantity;
      const newTotalCost = newPricePerItem * newQuantity;
      let savingAfterAddingThisUpsell = currentTotalCost - newTotalCost;
      savingAfterAddingThisUpsell += (this.selectedVariant.compare_at_price) ? ( this.selectedVariant.compare_at_price / 100 - currentPricePerItem ) : 0;
      // If no next tier exists and no savings from tier change, show per-item discount
      if (savingAfterAddingThisUpsell === 0) {
        // Calculate savings for 1 item: difference between regular price and current tier price
        savingAfterAddingThisUpsell = regularPrice - currentPricePerItem;
      }
      if (savingAfterAddingThisUpsell <= 0) {
        // 2. update upsell title 
        this.querySelector('.cart-item__upsell-title').textContent = `YOU MAY ALSO LIKE`;
        const priceEl = this.querySelector('.cart-item__upsell-price');
        if (priceEl) {
          priceEl.textContent = Shopify.formatMoney(this.selectedVariant.price).replace(/(\.|,)00\b/, '');
        }
      }else{ 
      // 2. update upsell title 
      // get currency symbol from formatted price
      const formattedSavingAmount = Shopify.formatMoney(savingAfterAddingThisUpsell * 100).replace(/[.,]\d+/, ''); // Format and remove decimal point and everything after it
      this.querySelector('.cart-item__upsell-title').textContent = `Add 1 More and Save ${formattedSavingAmount}`;
      }
      

      // 3. hide price 


    }else{
      // =============== UI for static item ===============

      // 1. Update upsell title
      this.querySelector('.cart-item__upsell-title').textContent = `YOU MAY ALSO LIKE`;

      // 2. Update price
      const priceEl = this.querySelector('.cart-item__upsell-price');
      if (priceEl) {
        priceEl.textContent = Shopify.formatMoney(this.selectedVariant.price).replace(/(\.|,)00\b/, '');
      }


    }
    // ========================== Changes for both pack and static item ==========================


    // Update selected options text
    const selectedEl = this.querySelector('.cart-item__upsell-selected');
    if (selectedEl) {
      selectedEl.textContent = [this.selectedVariant.option1, this.selectedVariant.option2, this.selectedVariant.option3]
        .filter(Boolean)
        .join(' / ');
    }

    // update image
    const imgEl = this.querySelector('.cart-item__upsell-image img');
    if (imgEl) {
      const variantImage = this.selectedVariant.featured_image?.src
        ? this.selectedVariant.featured_image.src.replace(/^\/\//, 'https://')
        : this.upsellItem.featured_image;
      imgEl.src = variantImage;
    }

    // Update button state
    const addBtn = this.querySelector('.cart-item__upsell-add');
    if (addBtn) {
      if (this.selectedVariant.available) {
        addBtn.textContent = 'Add';
        addBtn.disabled = false;
        addBtn.classList.remove('soldout');
      } else {
        addBtn.textContent = 'Sold Out';
        addBtn.disabled = true;
        addBtn.classList.add('soldout');
      }
    }

    // Ensure option radios reflect this.selectedVariant
    const option1 = this.selectedVariant.option1;
    const option2 = this.selectedVariant.option2;
    const option3 = this.selectedVariant.option3;

    if (option1) {
      const el = this.querySelector(`input[name="upsell-Color"][value="${CSS.escape(option1)}"], input[name="upsell-Colour"][value="${CSS.escape(option1)}"]`);
      if (el) el.checked = true;
    }
    if (option2) {
      const el = this.querySelector(`input[name="upsell-Size"][value="${CSS.escape(option2)}"]`);
      if (el) el.checked = true;
    }
    if (option3) {
      // Dynamically find the third option input by checking all non-Color/Size options
      const thirdOptionInputs = this.querySelectorAll('input[name^="upsell-"]');
      let thirdOptionName = null;
      thirdOptionInputs.forEach(input => {
        const optionName = input.name.replace('upsell-', '');
        if (optionName !== 'Color' && optionName !== 'Colour' && optionName !== 'Size') {
          thirdOptionName = optionName;
        }
      });
      
      if (thirdOptionName) {
        const el = this.querySelector(`input[name="upsell-${thirdOptionName}"][value="${CSS.escape(option3)}"]`);
        if (el) el.checked = true;
      }
    }
  }

  addToCart(_this) {
    if (!_this.selectedVariant) return;

    const cart = document.querySelector("cart-drawer");
    const form = document.querySelector(".cart-form #cart-form");

    let formData = {}

     if (cart) {
      formData["sections"] = cart.getSectionsToRender().map((section) => section.id)
      formData["sections_url"] = window.location.pathname
      formData["items"] = [{
        'id': _this.selectedVariant.id,
        'quantity': 1,
         properties: _this.isFinalSaleSelected() ? { _LPROP: 'Final Sale' } : {}
        }]
      cart.setActiveElement(document.activeElement);
    }


     fetch(window.Shopify.routes.root + 'cart/add.js', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(formData)
     })
     .then((response) => response.json())
     .then(response => {
        cart.renderContents(response);
        cart.setActiveElement(document.activeElement);

        setTimeout(() => {
          fetchCart();          
        }, 50)
     })
     .catch((error) => {
       console.error('Error:', error);
     });
  }

  render() {
    const _this = this;

    if (!this.upsellItem) { return; }

    const options_with_values = this.buildOptionsWithValues(this.upsellItem);

    // Update product info
    const nameEl = this.querySelector('.cart-item__upsell-name');
    if (nameEl) {
      nameEl.textContent = this.upsellItem.title;
    }

    const linkEl = this.querySelector('.cart-item__upsell-image');
    if (linkEl) {
      linkEl.href = this.upsellItem.url;
    }

    const imgEl = this.querySelector('.cart-item__upsell-image img');
    if (imgEl) {
      imgEl.src = this.upsellItem.selectedVariant?.featured_image || this.upsellItem.featured_image;
      imgEl.alt = this.upsellItem.title;
    }

    // Populate option forms
    this.populateOptionForms(options_with_values);

    // Update UI with selected variant
    this.updateUpsellUI();

    // Attach event listeners
    this.attachEventListeners();

    const addBtn = this.querySelector(".cart-item__upsell-add");
    if (addBtn) {
      addBtn.addEventListener('click', function (e){
        e.target.disabled = true;
        e.target.classList.add('disabled');
        _this.addToCart(_this);
      });
    }


    this.querySelector('.cart-item__upsell-card').classList.remove('loading');
  }

  populateOptionForms(options_with_values) {
    const variantRadios = this.querySelector('.upsell-form__variant-radios');
    if (!variantRadios) return;

    // Clear existing content
    variantRadios.innerHTML = '';

    options_with_values.forEach(option => {
      if (option.name === 'Color' || option.name === 'Colour') {
        const colorContainer = document.createElement('div');
        colorContainer.className = 'upsell-form-option upsell-form__input upsell-form__color-swatches';
        colorContainer.innerHTML = `
          <div class="upsell-form__normal-swatches">
            <div class="upsell-form__option-values">
              ${option.values.filter(value => !(typeof value === 'string' && value.startsWith('_'))).map(value => `
                <input
                  type="radio"
                  id="upsell-${option.name}-${value}"
                  name="upsell-${option.name}"
                  value="${value}"
                  ${option.selected_value === value ? 'checked' : ''}
                >
                <label
                  class="color-swatch"
                  for="upsell-${option.name}-${value}">
                  <span
                    class="color-swatch__inner"
                    style="background-image: url(https://unbound-merino.myshopify.com/cdn/shop/files/color-${value.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')}.png)"
                    title="${value}">
                  </span>
                </label>
              `).join('')}
            </div>
          </div>
        `;
        variantRadios.appendChild(colorContainer);
      } else {
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'upsell-form-option upsell-form__input upsell-form__buttons';
        buttonContainer.classList.add('hidden');
        buttonContainer.innerHTML = `
          <div class="upsell-form__option-values" style="grid-template-columns: repeat(5, minmax(0, 1fr));">
            ${option.values.map(value => `
              <input
                type="radio"
                id="upsell-${option.name}-${value}"
                name="upsell-${option.name}"
                value="${value}"
                ${option.selected_value === value ? 'checked' : ''}
              >
              <label class="upsell-form__button-label" for="upsell-${option.name}-${value}">
                ${value}
              </label>
            `).join('')}
          </div>
        `;
        variantRadios.appendChild(buttonContainer);
      }
    });
  }

  attachEventListeners() {
    const _this = this;
    
    // Remove existing listeners to prevent duplicates
    this.querySelectorAll('.upsell-form__input input[type="radio"]').forEach(input => {
      input.removeEventListener('change', _this.onVariantChange);
    });

    // Attach new listeners
    this.querySelectorAll('.upsell-form__input input[type="radio"]').forEach(input => {
      input.addEventListener('change', function(e){
        e.stopPropagation();
        _this.onVariantChange();
      });
    });
  }

  async init() {
    // Only initialize when cart drawer is open or container is inside the drawer
    const isDrawerOpen = document.body.classList.contains('cart-opened');
    const isInDrawer = !!(this.closest('cart-drawer') || document.getElementById('CartDrawer')?.contains(this));
    if (!isDrawerOpen && !isInDrawer) {
      return;
    }
    // if any cart item has bundle discount, return
    setTimeout(() => {
    const cartItems = document.querySelectorAll('.cart-item');
    const hasBundleDiscount = Array.from(cartItems).some(item => {
      const discount = item.querySelector('.discounts__discount');
      if (discount) {
        let discountText = discount.textContent.replace(/\s+/g, ' ').trim().toLowerCase();  
        return discountText.includes('bundle') || discountText.includes(' + '); 
      } 
      return false;
    });
    if (hasBundleDiscount) {
      this.closest('.drawer__inner').classList.add('hide-custom-upsell');
        return;
      }
      this.closest('.drawer__inner').classList.remove('hide-custom-upsell');
    }, 300);
    var upsellItemObject = await this.getUpsellItem();
    this.upsellItem = upsellItemObject ? upsellItemObject : null
    if (this.upsellItem) {
      const initialSearch = (this.cartVariant && this.cartVariant.length) ? this.cartVariant : (this.upsellItem.variants?.[0]?.title || '');
      this.selectedVariant = this.findMatchingVariant(this.upsellItem, initialSearch);
    } else {
      this.selectedVariant = null;
    }

    this.render()
  }
  buildOptionsWithValues(product) {
    const options = [];

    product.options.forEach((op, index) => {
      const position = index + 1;
      const values = [...new Set(product.variants.map(v => v[`option${position}`]).filter(Boolean))];

      // Use currently selected variant if present; otherwise fall back to first variant
      const selected_value = this.selectedVariant
        ? this.selectedVariant[`option${position}`]
        : product.variants[0][`option${position}`];

      options.push({
        name: op.name,
        values,
        selected_value
      });
    });

    return options;
  }

  findMatchingVariant(product, searchString) {
    const parts = searchString.split('/').map(s => s.trim());
    const [color, size, third] = parts;

    const variants = product.variants;

    // 1. Try to find exact match
    const exactMatch = variants.find(v =>
      (v.option1?.trim().toLowerCase() === color?.toLowerCase()) &&
      (v.option2?.trim().toLowerCase() === size?.toLowerCase()) &&
      (third ? v.option3?.trim().toLowerCase() === third.toLowerCase() : true)
    );
    if (exactMatch) return exactMatch;

    // 2. Try to find first available variant with same size (and same third if present)
    const sameSizeAvailable = variants.find(v =>
      v.option2?.trim().toLowerCase() === size?.toLowerCase() &&
      (third ? v.option3?.trim().toLowerCase() === third.toLowerCase() : true) &&
      v.available
    );
    if (sameSizeAvailable) return sameSizeAvailable;

    // 3. Fallback: first variant
    return variants[0];
  }
}

customElements.define("cart-pack-upsell", CartPackUpsell);

// Initialize the custom element when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  const upsellElement = document.querySelector('cart-pack-upsell');
  if (upsellElement) {
    upsellElement.init();
  }
});
